<template>
  <b-card no-body >
    <b-card-body>
      <div class="d-flex justify-content-between  flex-wrap">
        <!-- Registar Empresa  -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="traerEmpresas"
          >
            <feather-icon
                icon="RefreshCwIcon"
            />
          </b-button>
          <b-button
              variant="gradient-primary"
              size="sm"
              @click="descargarFile"
          >
            <span v-if="loading2"> Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" /></span>
            <span v-else>
              <feather-icon
                  icon="ExternalLinkIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar Excel</span>
            </span>


          </b-button>
        </b-form-group>

        <!-- filter -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Buscar"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Borrar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </div>
    </b-card-body>

    <b-table
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>
      <template #cell(estado_e)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(fecha)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value).toLocaleString('pe-PE', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              localeMatcher: 'best fit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              timeZone: 'America/Lima'
            })
          }}
        </span>
      </template>
      <template #cell(nombre_trabajador)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(observacion)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(latitud)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(longitud)="data">
        <span class="text-nowrap">{{data.value}}</span>
      </template>
      <template #cell(con_evaluador)="data">
        <span class="text-nowrap">{{data.value.apellidos}}, {{data.value.nombres}}</span>
      </template>
      <template #cell(fotos_ryr)="data">
        <feather-icon
            :id="`btn_${data.item.id}_verfoto`"
            icon="EyeIcon"
            class="text-primary mr-50"
            size="18"
            @click="eliminarRegistro(data.value)"
        />
        <b-tooltip
            title="Ver Fotos"
            :target="`btn_${data.item.id}_verfoto`"
        />
        <span class="text-nowrap">{{data.value.length}}</span>
      </template>
      <template #cell(ubicacion)="data">
        <span class="text-nowrap">
          <b-link
              :href="`https://www.google.com/maps/place/${data.item.latitud},${data.item.longitud}`"
              class="font-weight-bold d-block text-nowrap"
              target="_blank"
          >
              {{data.item.latitud}}, {{data.item.longitud}}
            </b-link>
        </span>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        :ok-title="infoModal.boton"
        ok-only
        ok-title="Aceptar"
        :title="`Total de Fotos: ${this.fotos.length}`"
        scrollable
    >
      <b-row>
        <b-col
            v-for="(item, index) in this.fotos"
            :key="item.id"
            lg="12"
        >
          <b-card
              :img-src="item.file"
              overlay
              text-variant="white"
              img-alt="card img"
              body-class="bg-overlay"
          >
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
  BSpinner,
  BLink,
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    BLink,
    BImg,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        /*
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },

        {
          key: 'cod',
          label: 'Código',
          sortable: true
        },
        */
        {
          key: 'dni_trabajador',
          label: 'DNI Trabajador',
          sortable: true
        },
        {
          key: 'nombre_trabajador',
          label: 'Nombres del Trabajador',
          sortable: true
        },
        {
          key: 'observacion',
          label: 'Observación',
          sortable: true
        },
        {
          key: 'ubicacion',
          label: 'Ubicación',
          sortable: true
        },
        {
          key: 'fecha',
          label: 'Fecha y Hora',
          sortable: true
        },
        {
          key: 'estado_e',
          label: 'Estado Trabajador',
          sortable: true
        },
        {
          key: 'con_evaluador',
          label: 'Evaluador',
          sortable: true
        },
        {
          key: 'fotos_ryr',
          label: 'N° de Fotos',
          sortable: true
        },
      ],
      items: [],
      status: [
        {
          'Activo': 'Activo',
          'Inactivo': 'Inactivo',
        },
        {
          'Activo': 'light-success',
          'Inactivo': 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 0, text: "Activo"},
        {value: 1, text: "Inactivo"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: {value: 0, text: "Activo"},
      id: 0,
      tipo: 0,
      loading2: false,
      loading: false,

      fotos: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEmpresas();
  },
  methods: {
    traerEmpresas(){
      var yo = this
      yo.loading = true

      var config = {
        method: 'get',
        url: '/ryr/registrosryr/'
      };

      axiosIns(config)
      .then(function (response) {
        if(response.status === 200){
          yo.items = response.data;
          yo.totalRows = yo.items.length
        }

      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function (){
        yo.loading = false
      });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id, codigo, descrip, nombre, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Empresa'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Empresa'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.codigo = codigo
        this.descrip = descrip
        this.nombre = nombre

        this.estado = {value: parseInt(estado), text: estado === '0' ? 'Activo' : 'Inactivo'}
      }
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
        component: ToastificationContent,
        props:{
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
      {
        timeout: 5000
      })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = {value: 0, text: "Activo"}
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this

        var data = JSON.stringify({
          "cod": yo.codigo,
          "descrip": yo.descrip,
          "nombre": yo.nombre,
          "estado": yo.estado.value.toString()
        });

        var url = this.tipo === 1 ? '/configuracion/empresas/crear/' : '/configuracion/empresas/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.traerEmpresas();

                if (yo.tipo === 1){
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'La empresa ' + response.data.cod + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'La empresa ' + yo.codigo + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    eliminarRegistro(fotos){
      console.log(fotos)
      this.estadoModal = true;
      this.fotos = fotos;
      console.log(this.fotos.length)
    },

    descargarFile(){
      var yo = this
      this.loading2 = true
      var config = {
        method: 'post',
        url: '/ryr/registrosryr/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              console.log("Enviado")

              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'RegistrosRyR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
                  {
                    position: 'top-center',
                  })
            }
            else if(response.status === 204){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'No existen registros',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encontraron registros con los parámetros solicitados.',
                  variant: 'warning',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading2 = false
          });
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
